module Meevo.Plugins.Product {
    import ProductUsageAmountTypeEnum = Meevo.Model.ProductUsageAmountTypeEnum;

    export class MarketPricingController {
        static $inject = [
            "$mdDialog",
            "meevo.components.common.DataService",
            "meevo.AppSettings", 
            "meevo.components.common.IdentityService",
            "meevo.components.busy.BusyService",
            "meevo.components.common.SecurityService",
            "options", 
            "$timeout",
            "$translate", 
            "meevoDateFilterFilter",
            "$mdBottomSheet",
            "$rootElement"
        ];
        public product : Meevo.Model.Product = null;
        public variants;
        public saleDataFetched: boolean;
        public fetchingData: boolean;
        public criteria;
        public activeTabIndex;
        public variantsDrilledInto : Meevo.Model.Variant[] = [];
        public salesDateRange: any;
        private holdScrollTop: number = 0;
        public selectedVariant: Meevo.Model.Variant;
        public showModelQuantityAndOrderPoint : boolean = false;
        public showSalesData : boolean = false;
        public salesButtonLabel : string;
        protected decimalPrecision: number;
        public tenantEnableProductUsageTracking: boolean = false;
        public title: string = null;
        constructor(
            private $mdDialog: angular.material.IDialogService,
            public dataService: Meevo.Components.BaseClasses.IDataService,
            private appSettings: Meevo.Components.Common.IAppSettings,
            public identityService: Meevo.Components.Common.IIdentityService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            private securityService: Meevo.Components.Common.ISecurityService,
            private options: MarketPricingModalOptions,
            public $timeout: angular.ITimeoutService,
            public $translate: ng.translate.ITranslateService,
            public meevoDateFilter: any,
            public $mdBottomSheet: angular.material.IBottomSheetService,
            public $rootElement: angular.IRootElementService) {
            

            this.decimalPrecision = this.appSettings.APP_BUSINFOSETTINGS.generalSettings.inventoryDecimalPrecision || 4;
            this.tenantEnableProductUsageTracking = this.appSettings.APP_BUSINFOSETTINGS.generalSettings.productUsageTracking || false;
            this.title = this.options.title;            
        }

        $onInit() { 
            this.variants = [];
            this.dataService.customMethodData(`${this.appSettings.API_ROOT}/ProductVariantPrice/List/${this.options.variantId }`, 'GET', null).then((res: any) => {
                this.variants = res.data;
                this.setMarkUpValue(this.variants);
            });
        }
        
        setMarkUpValue(variants) {
            variants.map(item => {
                if (item.wholeSale > 0 && (item.retail / item.wholeSale) - 1 > 0)
                    item.markUp = ((item.retail / item.wholeSale) - 1).toFixed(4);
                else
                    item.markUp = 0.0;
            })
        }

        processPricing(variant: any, currentlyEditing: string) {
            if (currentlyEditing == "Wholesale") {
                if (variant.markUp == 0) {
                    //if (variant.wholeSale > 0) {
                    variant.retail = variant.wholeSale;
                    //}
                }
                else {
                    if (variant.wholeSale > 0 && (variant.wholeSale <= variant.retail)) {
                        variant.markUp = ((variant.retail - variant.wholeSale) / variant.wholeSale).toFixed(4);
                    }
                    else {
                        variant.markUp = 0.0;
                    }
                }
            }
            else if (currentlyEditing == "Retail") {
                if (variant.wholeSale > 0 && (variant.wholeSale <= variant.retail)) {
                    variant.markUp = ((variant.retail - variant.wholeSale) / variant.wholeSale).toFixed(4);
                }
                else {
                    variant.markUp = 0.0
                }
            }
            else /* if (currentlyEditing == "Markup") */ {
                if (variant.wholeSale > 0) {
                    variant.retail = (variant.wholeSale + (variant.wholeSale * variant.markUp)).toFixed(2);
                }
            }
        }
        closeModal(e): void {
            if (e) e.stopPropagation();
            this.$mdDialog.hide();
        }
        applyChanges(e): void {
            var postData = {
                variantId: this.options.variantId,
                productVariantPriceGroupPrices: this.variants.map(item => ({
                    PriceGroupId: item.priceGroupId,
                    WholeSale: item.wholeSale,
                    Markup: item.markUp,
                    Retail: item.retail
                }))
            }
            this.dataService.customMethodData(`${this.appSettings.API_ROOT}/ProductVariantPrice/`, 'POST', postData).then((res: any) => {
                if (res.data) {
                    this.$mdDialog.hide();
                }
            });
        }
    }
    
    angular.module("meevo.plugins.product")
        .controller("meevo.plugins.product.MarketPricingController", MarketPricingController);
}